import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

import { isExpand } from "@/views/Home/useData/useHomePage";
import LeftHeader from "./LeftHeader.vue";
import UserInfoBar from "@/views/Home/components/UserInfoBar.vue";
import ChatList from "@/views/Home/components/ChatList.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'LeftSideBar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["side-bar", { close: !_unref(isExpand) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LeftHeader),
      _createVNode(ChatList),
      _createVNode(UserInfoBar)
    ])
  ], 2))
}
}

})